angular.module('zc.master')
  .component('zcMasterHome', {
    templateUrl: '/templates/master/components/master_home/master_home.html',
    bindings: {
      projects: '<'
    },
    controller: zcMasterHome,
  });


zcMasterHome.$inject = ['$scope', '$q', '$filter', 'Devise', 'SearchFilter', 'CampaignStats', 'MasterCampaign', 'MasterCampaignStats', 'MasterAccessStats', 'MasterCampaignSegmentStats', 'currencies'];
function zcMasterHome($scope, $q, $filter, Devise, SearchFilter, CampaignStats, MasterCampaign, MasterCampaignStats, MasterAccessStats, MasterCampaignSegmentStats, currencies) {

  const vm = this;

  vm.starredApikeyMap = _.reduce(Devise.currentUser.projects, (memo, project) => {
    memo[project.apikey] = true;
    return memo;
  }, {});

  vm.alertProjects = [];
  vm.reportProjects = [];
  vm.reportCampaigns = [];
  vm.updateFilters = updateFilters;
  vm.updateReports = updateReports;
  vm.resetFilters = resetFilters;
  vm.sortReports = sortReports;

  vm.$onInit = () => {
    _.each(vm.projects, project => {
      project.currencyObj = currencies[project.currency];
    });
    vm.filters = SearchFilter.resolveFromLocation();

    SearchFilter.setComponentDefaults('home', {
      expanded_alert: { default: false },
      all_alert: { default: false },
      expanded_report: { default: false },
      flat_report: { default: false },
      all_report: { default: false },
      column_report: { default: 'kgi' },
      sort_prop: { default: 'project.id' },
      sort_direction: { default: 'asc' },
      include_hidden_ab_test: { default: false }
    });
  };

  function updateFilters() {
    _.merge(vm.filters, {
      start_at: moment(vm.filters.start_at).toDate(),
      end_at: moment(vm.filters.end_at).endOf('day').toDate()
    });
    SearchFilter.set(vm.filters);
    $scope.$broadcast('filtersUpdated');
    vm.updateReports();
  }

  function resetFilters() {
    $scope.$broadcast('filtersReset');
  }

  function updateReports() {
    $q.all([getCampaigns(), getCampaignStats(), getAccessStats(), getCampaignSegmentStats()])
      .then(res => {
        const [campaigns, campaignStats, accessStats, campaignSegmentStats] = res;
        vm.reportProjects = _.filter(vm.projects, project => _.includes(['zenclerk', 'zenclerk_lp'], project.product_line));
        vm.reportCampaigns = [];
        _.each(vm.reportProjects, project => {
          project.starred = vm.starredApikeyMap[project.apikey];
          project.expanded_alert = vm.filters.expanded_alert;
          project.expanded_report = vm.filters.expanded_report;
          project.campaigns = _.filter(campaigns, { project_id: project.id, is_information_campaign: false });
          const nonAovCampaigns = _.filter(project.campaigns, { is_aov_campaign: false });
          vm.reportCampaigns = vm.reportCampaigns.concat(project.campaigns);
          project.stats = getDefaultStats();
          if(project.campaigns.length === 0) return;
          const filteredStats = _.filter(campaignStats, { apikey: project.apikey });
          const statsById = MasterCampaignStats.statsById(filteredStats);
          const conversionCount = _.get(accessStats, `${project.apikey}.conversion_count`, 0);
          _.each(project.campaigns, campaign => {
            campaign.project = project;
            campaign.stats = statsById[campaign.id];
            if(campaign.stats) {
              MasterCampaignStats.calculate(campaign.stats);
              campaign.stats.invoice_amount = CampaignStats.calculateInvoiceAmount(project, campaign, campaign.stats);
              campaign.stats.invoice_amount_simulation = campaign.stats.invoice_amount * calculateSimulation();
              campaign.stats.conversion_price = campaign.stats.experimental.conversion_price;
              campaign.stats.revenue_simulation = campaign.stats.experimental.conversion_price * calculateSimulation();
              campaign.stats.conversion_count = conversionCount;
              campaign.stats.conversion_cover_rate =
                conversionCount >= 1
                  ? campaign.stats.experimental.conversion_count / conversionCount
                  : null;
            } else {
              campaign.stats = getDefaultStats();
            }
            const campaignSegmentStat = _.find(campaignSegmentStats, { apikey: project.apikey, campaign_id: campaign.id });
            campaign.stats.coupon_applicable_rate =
              campaignSegmentStat && campaignSegmentStat.conversion_count >= 1
                ? campaignSegmentStat.coupon_applicable_conversion_count / campaignSegmentStat.conversion_count
                : null;
            campaign.alerts = judgeAlerts(project, campaign.stats);
          });
          project.stats = {
            experimental: {
              delivery_count: _.sumBy(
                project.campaigns,
                'stats.experimental.delivery_count'
              ),
              conversion_count: _.sumBy(
                project.campaigns,
                'stats.experimental.conversion_count'
              ),
            },
            control: {
              delivery_count: _.sumBy(
                project.campaigns,
                'stats.control.delivery_count'
              ),
              conversion_count: _.sumBy(
                project.campaigns,
                'stats.control.conversion_count'
              ),
            },
            conversion_up_rate: $filter('overallCampaignCvrIncreaseRate')(
              nonAovCampaigns,
              vm.filters.include_hidden_ab_test
            ),
            total_conversion_value: _.sumBy(
              nonAovCampaigns,
              'stats.experimental.conversion_price'
            ),
            invoice_amount: _.sumBy(project.campaigns, 'stats.invoice_amount'),
            invoice_amount_simulation: _.sumBy(
              project.campaigns,
              'stats.invoice_amount_simulation'
            ),
            revenue_simulation: _.sumBy(
              project.campaigns,
              'stats.revenue_simulation'
            ),
            conversion_count: conversionCount,
          };
          project.stats.conversion_cover_rate =
            conversionCount >= 1
              ? project.stats.experimental.conversion_count / conversionCount
              : null;
          project.alerts = judgeAlerts(project, project.stats);
          if(_.find(project.campaigns, campaign => campaign.alerts.includes('coupon_applicable_rate'))) {
            project.alerts.push('coupon_applicable_rate');
          }
        });
        sortReports();
        filterAlerts();
      });
  }

  function filterAlerts() {
    vm.alertProjects = [];
    _.each(vm.reportProjects, project => {
      _.each(project.alerts, alert => {
        vm.alertProjects.push(_.merge({}, project, { alert: alert }));
      });
    });
  }

  function sortReports() {
    const reverse = (vm.filters.sort_direction === 'desc');
    vm.reportProjects = $filter('orderBy')(vm.reportProjects, vm.filters.sort_prop, reverse);
    vm.reportProjects = $filter('emptyToEnd')(vm.reportProjects, vm.filters.sort_prop, reverse);
    vm.reportCampaigns = $filter('orderBy')(vm.reportCampaigns, vm.filters.sort_prop, reverse);
    vm.reportCampaigns = $filter('emptyToEnd')(vm.reportCampaigns, vm.filters.sort_prop, reverse);
  }

  function getCampaigns() {
    return MasterCampaign.all({
      fast: true,
      start_at: moment(vm.filters.start_at).valueOf(),
      end_at: moment(vm.filters.end_at).endOf('day').valueOf()
    });
  }


  function getCampaignStats() {
    return new MasterCampaignStats('daily').aggregate({
      start_at: moment(vm.filters.start_at).toDate(),
      end_at: moment(vm.filters.end_at).endOf('day').toDate()
    });
  }

  function getAccessStats() {
    return MasterAccessStats.aggregate({
      dimension: 'daily'
    }, {
      match: {
        device: null,
        is_control: null,
        campaign_segment_id: null,
        start_at: {
          $gte: moment(vm.filters.start_at).toDate(),
          $lt: moment(vm.filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: [{
        $group: {
          _id: '$apikey',
          conversion_count: {
            $sum: '$conversion_count'
          }
        }
      }]
    })
      .then(stats =>
        _.reduce(stats, (obj, stat) => {
          obj[stat._id] = stat;
          return obj;
        }, {})
      );
  }

  function getCampaignSegmentStats() {
    return MasterCampaignSegmentStats.aggregate({
      dimension: 'daily'
    }, {
      match: {
        start_at: {
          $gte: moment(vm.filters.start_at).toDate(),
          $lt: moment(vm.filters.end_at).endOf('day').toDate(),
        },
      },
      pipeline: [{
        $group: {
          _id: {
            apikey: '$apikey',
            campaign_id: '$campaign_id',
          },
          coupon_applicable_conversion_count: {
            $sum: '$coupon_applicable_conversion_count',
          },
          conversion_count: {
            $sum: '$conversion_count'
          },
        },
      }],
    })
      .then(stats =>
        _.map(stats, stat => _.merge({}, stat, stat._id))
      );
  }

  function getDefaultStats() {
    return {
      experimental: { delivery_count: 0 },
      control: { delivery_count: 0 },
      contribution_price: 0,
      contribution_count: 0,
      invoice_amount: 0,
      invoice_amount_simulation: 0,
      revenue_simulation: 0,
      conversion_up_rate: null,
      conversion_count: 0,
      conversion_cover_rate: null,
    };
  }

  function calculateSimulation() {
    const today = moment().add(1, 'day').startOf('day');
    const monthFrom = moment(vm.filters.start_at).startOf('month');
    const monthTo = moment(vm.filters.end_at).add(1, 'month').startOf('month');
    const months = monthTo.diff(monthFrom, 'months');
    const monthDays = monthTo.diff(monthFrom, 'days');
    const currentFrom = moment(vm.filters.start_at).startOf('day');
    const currentTo = moment.min(moment(vm.filters.end_at).add(1, 'day').startOf('day'), today);
    const currentDays = currentTo.diff(currentFrom, 'days');
    return monthDays / months / currentDays;
  }

  function judgeAlerts(project, stats) {
    const alerts = [];
    if(stats.conversion_up_rate &&
      project.conversion_up_rate_threshold &&
      stats.conversion_up_rate * 100 < project.conversion_up_rate_threshold) {
      alerts.push('conversion_up_rate');
    }
    if(stats.invoice_amount_simulation &&
      project.invoice_amount_threshold &&
      stats.invoice_amount_simulation < project.invoice_amount_threshold) {
      alerts.push('invoice_amount_simulation');
    }
    if(stats.invoice_amount_simulation &&
      project.invoice_amount_upper_threshold &&
      stats.invoice_amount_simulation >= project.invoice_amount_upper_threshold) {
      alerts.push('invoice_amount_upper_simulation');
    }
    if(stats.revenue_simulation &&
      project.revenue_min_threshold &&
      stats.revenue_simulation < project.revenue_min_threshold) {
      alerts.push('revenue_min_threshold');
    }
    if(stats.revenue_simulation &&
      project.revenue_max_threshold &&
      stats.revenue_simulation >= project.revenue_max_threshold) {
      alerts.push('revenue_max_threshold');
    }
    if(stats.coupon_applicable_rate !== null &&
      project.coupon_applicable_rate_threshold &&
      stats.coupon_applicable_rate * 100 < project.coupon_applicable_rate_threshold) {
      alerts.push('coupon_applicable_rate');
    }
    return alerts;
  }
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/components/master_home/master_home.js